<template>
    <div class="select_emul non_removable " tabindex="1">
        <div :class="{'select_emul_t': true, 'select_emul_t-c': selectedValues.length > 0}">
            <span class="select_emul_t_text" v-text="selectedValuesText"></span>
            <svg class="select_emul_t_arrow" width="10" height="7" viewBox="0 0 10 7"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5 5L9 1" stroke="#2C2A44" stroke-width="1.5"></path>
            </svg>
        </div>
        <div class="select_emul_list">
            <div class="select_emul_list_item select_emul_list_item-default" @click="selectAllValues()">Всі</div>
            <div v-for="(_value, key) in values"
                 :class="{
                     'select_emul_list_item': true,
                     'select_emul_list_item_hidden': _value.visible === false,
                     }"
                 @click="changeFilterValue(_value.id ? _value.id : key)"
                 >
                <label class="ui-check w-100">
                    <i v-if="includesValue(_value, key)" class="fas fa-check-square"></i>
                    <i v-else class="far fa-square"></i>
                    {{ _value.name ? _value.name : _value }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectComponent",

    props: ['value', 'name', 'values'],

    data: function () {
        return {
            selectedValues: [],
        };
    },

    mounted () {
        if(this.value) {
            this.value.forEach((_value) => {
                this.changeFilterValue(_value);
            });
        }

        if(this.value === 'null') {
            this.value = null;
        }

        this.$forceUpdate();
    },

    computed: {
        selectedValuesText() {
            if(this.selectedValues.length < 1) {
                return this.name;
            }

            else if(this.selectedValues.length === 1) {
                let selected = this.values.find((value) => {
                    return value.id === this.selectedValues[0];
                });
                return selected.name ? selected.name : selected;
            }

            else if(this.selectedValues.length > 1) {
                return this.name + ' [' + this.selectedValues.length + ']';
            }
        },
    },

    methods: {
        selectAllValues(){
            let selectedValues = [];
            for (const [key, value] of Object.entries(this.values)) {
                if(value.id){
                    selectedValues.push(value.id);
                }
            }
            if(this.selectedValues.length === selectedValues.length){
                this.selectedValues = [];
            }else{
                this.selectedValues = selectedValues;
            }
            this.$emit('input', this.selectedValues.length > 0 ? this.selectedValues : null);
        },
        changeFilterValue(value) {
            if(!isNaN(value)) {
                value = parseInt(value);
            }

            if(!value || value === null) {
                this.selectedValues = [];
            } else {
                if(!this.selectedValues.includes(value)) {
                    this.selectedValues.push(value);
                } else {
                    const index = this.selectedValues.indexOf(value);
                    this.selectedValues.splice(index, 1);
                }
            }

            this.$emit('input', this.selectedValues.length > 0 ? this.selectedValues : null);
        },

        includesValue(value, key) {
            for(let selectedValue of this.selectedValues) {
                if(value.id) {
                    if(selectedValue === value.id) {
                        return true;
                    }
                } else {
                    if(selectedValue === key) {
                        return true;
                    }
                }
            }

            return false;
        }
    },
}
</script>
